import { GetClientsQuery } from "./clients.api";

const clientsQueryKeys = {
  list: (q?: GetClientsQuery) => ["clients", "list", q],
  infiniteList: (q?: GetClientsQuery) => ["clients", "infinite-list", q],
  detail: (clientId: number) => ["clients", clientId],
  organizations: () => ["clients", "organizations"],
};

export const ClientsQuery = {
  queryKeys: clientsQueryKeys,
};
